module.exports = __webpack_public_path__ + "media/images/march8/march8-template-kz-e89eeff2bd2f74dd9ee5675fd1070147.png";